import React from "react";

interface LinkedinIconProps {
    width?: number;
    height?: number;
    className?: string;
}

const Linkedin: React.FC<LinkedinIconProps> = ({width, height, className}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" 
        width={width} 
        height={height} 
        viewBox="0 0 48 48" 
        fill="none"
        className={className}
        >
            <path d="M39.7359 5.25H8.26406C6.6 5.25 5.25 6.6 5.25 8.26406V39.7359C5.25 41.4 6.6 42.75 8.26406 42.75H39.7359C41.4 42.75 42.75 41.4 42.75 39.7359V8.26406C42.75 6.6 41.4 5.25 39.7359 5.25ZM39.7359 39.75C18.7453 39.7453 8.25 39.7406 8.25 39.7359C8.25469 18.7453 8.25938 8.25 8.26406 8.25C29.2547 8.25469 39.75 8.25938 39.75 8.26406C39.7453 29.2547 39.7406 39.75 39.7359 39.75ZM10.8094 19.3078H16.3734V37.2047H10.8094V19.3078ZM13.5938 16.8609C15.3703 16.8609 16.8187 15.4172 16.8187 13.6359C16.8187 13.2124 16.7353 12.7931 16.5733 12.4018C16.4112 12.0105 16.1736 11.655 15.8742 11.3555C15.5747 11.056 15.2192 10.8185 14.8279 10.6564C14.4366 10.4944 14.0173 10.4109 13.5938 10.4109C13.1702 10.4109 12.7509 10.4944 12.3596 10.6564C11.9683 10.8185 11.6128 11.056 11.3133 11.3555C11.0139 11.655 10.7763 12.0105 10.6142 12.4018C10.4522 12.7931 10.3687 13.2124 10.3687 13.6359C10.3641 15.4172 11.8078 16.8609 13.5938 16.8609ZM25.4203 28.35C25.4203 26.0156 25.8656 23.7562 28.7578 23.7562C31.6078 23.7562 31.65 26.4234 31.65 28.5V37.2047H37.2094V27.3891C37.2094 22.5703 36.1688 18.8625 30.5391 18.8625C27.8344 18.8625 26.0203 20.3484 25.275 21.7547H25.2V19.3078H19.8609V37.2047H25.4203V28.35Z"/>
        </svg>
    )
}

export default Linkedin